export const environment = {
  production: false,
  zisApiBaseUrl: 'https://zenithapi-devtest.zis.com/api/',
  cookieDomain: '.zis.com',
};
